import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  // IconBrandGoogleFilled,
  IconEye,
  IconEyeOff,
} from "@tabler/icons-react";
import { AuthServiceContext } from "../../services/auth/authService";
import TwoFactorModal from "./TwoFactorModal";
import { useUserContext } from "../../context/user_context";
import RecaptchaComponent from "../../components/RecaptchaComponent";
import { UserService } from "../../services/user/userService";
import { CommonService } from "../../services/common/commonService";

export default function Signin() {
  const { login } = useContext(AuthServiceContext);
  const { captchaState, setCaptchaState } = useUserContext();
  const [errors, setErrors] = useState({});
  const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);
  const [showRecaptcha, setShowRecaptcha] = useState(false);
  const [apiErrors, setApiErrors] = useState({});

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    recaptchaCode: "",
    smsCode: "",
  });

  const validateForm = () => {
    const newErrors = {};

    if (!formData.userName) {
      newErrors.userName = "მომხმარებლის სახელი აუცილებელია";
    }

    if (!formData.password) {
      newErrors.password = "პაროლი აუცილებელია";
    }
    //console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openTwoFactorModal = (value) => {
    setShowTwoFactorModal(value ?? !showTwoFactorModal);
  };

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  useEffect(() => {
    if (!captchaState.token) {
      openTwoFactorModal(false);
    }
  }, [captchaState]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const credentials = { ...formData, recaptchaCode: captchaState.token };
    const response = await login(credentials);
    //console.log(response);
    if (response.recaptchaRequested && !response.token) {
      setShowRecaptcha(true);
      return;
    }
    if (response.auth2FaEnabled) {
      setShowTwoFactorModal(true);
    }
    if (response && !response.success) {
      if (response.code == -2) {
        const newErrors = {};
        newErrors.password = "მომხმარებელი ან პაროლი არასწორია";
        setErrors(newErrors);
      }
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <CommonService>
        <UserService>
          {showTwoFactorModal && (
            <TwoFactorModal
              setCreateEventModal={openTwoFactorModal}
              formData={formData}
              askSms={true}
              setFormData={setFormData}
              apiErrors={apiErrors}
              setApiErrors={setApiErrors}
              authType="login"
            />
          )}
        </UserService>
      </CommonService>
      <div className="sm:mb-8 mb-6 text-center">
        <div className="sm:text-[40px]/[48px] text-[30px]/[36px] font-medium mb-2">
          ავტორიზაცია
        </div>
        {/* <span className="text-font-color-100 inline-block">
          Free access to our dashboard.
        </span> */}
      </div>
      {/* <div className="sm:mb-6 mb-4 text-center">
        <Link to="#" className="btn btn-white !border-border-color">
          <IconBrandGoogleFilled className="fill-font-color-100" />
          Sign in with Google
        </Link>
        <div className="mt-6 flex items-center">
          <span className="inline-block h-[1px] w-full bg-font-color-400"></span>
          <span className="px-30 text-font-color-400">OR</span>
          <span className="inline-block h-[1px] w-full bg-font-color-400"></span>
        </div>
      </div> */}
      <form onSubmit={handleSubmit}>
        <div className="form-control mb-15">
          <label htmlFor="username" className="form-label">
            მომხმარებელი
          </label>
          <input
            id="username"
            placeholder="მომხმარებლის სახელი"
            className="form-input"
            name="userName"
            onChange={(e) => handleChange(e)}
          />

        </div>
          {errors.userName && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.userName}
            </div>
          )}
        <div className="form-control mb-15">
          <label htmlFor="password" className="form-label">
            პაროლი
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder="პაროლი"
              name="password"
              className="form-input !pr-12"
              onChange={(e) => handleChange(e)}
            />
            <button
             type="button"
              onClick={togglePasswordVisibility}
              className="absolute top-[50%] translate-y-[-50%] right-3 text-font-color-100"
            >
              {showPassword ? <IconEyeOff /> : <IconEye />}
            </button>
          </div>
            {errors.password && (
              <div className="text-danger text-[14px]/[20px]">
                {errors.password}
              </div>
            )}
        </div>
        {showRecaptcha && (
          <div className="">
            {captchaState.ask && (
              <>
                <div
                  className="flex mb-20"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="auth-err-cont" style={{ marginTop: "10px" }}>
                    <RecaptchaComponent />
                  </div>
                  {errors.recaptchaCode && (
                    <div className="text-danger text-[14px]/[20px]">
                      {errors.recaptchaCode}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}
        <div className="flex flex-wrap items-center justify-between gap-10 sm:mb-30 mb-6">
          {/* <div className="form-check">
            <input
              type="checkbox"
              id="forgotPassword"
              className="form-check-input"
            />
            <label className="form-check-label" htmlFor="forgotPassword">
              Remember me
            </label>
          </div> */}
          <Link
            to="/auth-forgot-password"
            className="text-primary sm:text-[16px]/[24px] text-[14px]/[20px]"
          >
            დაგავიწყდა პაროლი?
          </Link>
        </div>
        <button
          type={"submit"}
          className="btn btn-secondary large w-full uppercase"
        >
          შესვლა
        </button>
        <div className="text-center sm:mt-30 mt-6 text-font-color-100">
          {/* <p>Don't have an account yet?</p> */}
          <Link to="/auth-signup" className="text-primary">
            რეგისტრაცია
          </Link>
        </div>
      </form>
    </>
  );
}
